import * as React from 'react';
import IdleTimer from 'react-idle-timer';
import {connect} from "react-redux";
import {CONTENT_TYPE, FORM_TYPE} from '../../Config/appConfig';
import {Auth, CoverNote, RecordCount} from '../../Config/dataModel';
import authState from '../../ReduxRequests/State/authState';
import Batch from '../Batch/Batch';
import CompanyController from '../Contact/ContactController/CompanyController';
import NormalUserController from '../Contact/ContactController/NormalUserController';
import ApiUserController from '../Contact/ContactController/ApiUserController';
import Dashboard from '../Dashboard/Dashboard';
import CommonFormController from '../Form/CommonFormController';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Idle from '../Auth/Idle';
import Records from '../Records/Records';
import Search from '../Search/Search';
import Settings from '../Settings/Settings';

interface AppContainerProps {
    content: string,
    newRecord?: CoverNote,
    newCount?: RecordCount,
    auth?: () => Auth,
    isInsurer?: () => boolean
}

interface AppContainerState {
	isIdle: boolean
}

class AppContainer extends React.Component <AppContainerProps, AppContainerState> {
	public idleTimer = null;
	
	public constructor(props: AppContainerProps) {
    	super(props);
		this.state = {
            isIdle: false
        };	
    	this.onActive = this.onActive.bind(this);
    	this.onIdle = this.onIdle.bind(this);
	}

	public onActive() {
		this.setState({ isIdle: false });
	}
 
	public onIdle() {
		this.setState({ isIdle: true });
	}

    public getContent() {
        switch (this.props.content) {
            case CONTENT_TYPE.DASHBOARD:
                return <Dashboard newCount={this.props.newCount}/>;
            case CONTENT_TYPE.CREATE:
                return <CommonFormController formType={this.props.isInsurer() ? FORM_TYPE.IN_CREATE_COVER_NOTE : FORM_TYPE.SA_CREATE_COVER_NOTE}/>;
            case CONTENT_TYPE.COVER_NOTE:
            case CONTENT_TYPE.POLICY:
            case CONTENT_TYPE.ARCHIVED:
                return <Records content={this.props.content} newRecord={this.props.newRecord} newCount={this.props.newCount}/>;
            case CONTENT_TYPE.VIEW_COVER_NOTE:
            case CONTENT_TYPE.VIEW_ARCHIVED_COVER_NOTE:
                return <CommonFormController formType={this.props.isInsurer() ? FORM_TYPE.IN_VIEW_COVER_NOTE : FORM_TYPE.UPDATE_COVER_NOTE}/>;
            case CONTENT_TYPE.VIEW_POLICY:
            case CONTENT_TYPE.VIEW_ARCHIVED_POLICY:
                return <CommonFormController formType={this.props.isInsurer() ? FORM_TYPE.UPDATE_POLICY : FORM_TYPE.SA_VIEW_POLICY}/>;
            case CONTENT_TYPE.BATCH:
                return <Batch/>;
            case CONTENT_TYPE.SEARCH:
                return <Search/>;
            case CONTENT_TYPE.SETTINGS:
                return <Settings/>;
            case CONTENT_TYPE.COMPANIES:
                return <CompanyController/>;
            case CONTENT_TYPE.NORMAL_USERS:
                return <NormalUserController/>;
            case CONTENT_TYPE.API_USERS:
                return <ApiUserController/>;
            default:
                return <Dashboard/>;
        }
    }

    public render() {
        return (
            <IdleTimer
                ref={ref => { this.idleTimer = ref }}
                element={document}
                onIdle={this.onIdle}
                timeout={1000 * 60 * 13}>
                    <div className="mainContainer">
                        <div className="cmContainer">
                            <Header
                                showMemberPanel={true}
                                name={this.props.auth().user.name}
                                company={this.props.auth().user.company}/>
                            {this.getContent()}
                            {this.state.isIdle && <Idle onCancel={this.onActive} />}
                        </div>
                        <Footer/>
                    </div>
            </IdleTimer>
        );
    }
}

export default connect<any, any, AppContainerProps>(authState, null)(AppContainer);



// WEBPACK FOOTER //
// ./src/Components/Containers/AppContainer.tsx